<script>
    import { apiURL } from '../../store.js'
    export let color
    export let items

    const getItemLink = async (item) => {
        item = item.content[0]
        if (item.type === 'link') {
            return item.value
        }
        if (item.type === 'PDF') {
            const detailURL = `${apiURL}/api/v2/documents/${item.value}/?format=json`
            const details = await fetch(detailURL).then(res => res.json())
            return details.meta.download_url
        }
        if (item.type === 'image') {
            const detailURL = `${apiURL}/api/v2/images/${item.value.id}/?format=json`
            const details = await fetch(detailURL).then(res => res.json())
            return `${apiURL}${details.meta.download_url}`
        }
        return 'javascript:void(0)'
    }

    const links = items.map(i => getItemLink(i))
</script>

<div class="outreachItems">
    {#each items as item, i}
        <div class="content">
            {@html item.text}
            {#if item.content.length != 0}
                {#await links[i]}
                    <a target="_blank" href={'javascript:void(0)'}>
                        {item.content[0].type}
                    </a>
                {:then link}
                    <a target="_blank" href={link} style="border-bottom: 2px solid {color}">
                        {item.content[0].type}
                    </a>
                {/await}
            {/if}
        </div>
    {/each}
</div>

<style lang="scss">
    @import "../../styles/vars";

    .content {
        margin: 1rem 0;

        a {
            font-family: "Ysabeau";
            font-style: italic;
            color: black;
            text-decoration: none;
            font-size: 1.3rem;
            display: inline;

            &:hover {
                text-decoration: none;
            }
        }
    }
    .outreachItems .content :global(p) {
        font-family: "Ysabeau";
        font-size: 1.25rem;
        margin: 0;
        display: inline;
    }

    @include respond-to(phone) {
        .content a {
            font-size: 1.1rem;
        }

        .outreachItems .content :global(p) {
            font-family: "Ysabeau";
            font-size: 1.08rem;
            line-height: 1.45rem;
            margin: 0.6rem 0 1rem 0;
        }
    }
</style>
